(function () {
  function normalize(str) {
    return (str || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function setActive(cards, activeCard) {
    cards.forEach((c) => c.classList.toggle("is-active", c === activeCard));
  }

  function updateMap(sectionEl, card) {
    const mapHost = sectionEl.querySelector("[data-dt-tiendas-map-host]");
    const placeholder = sectionEl.querySelector("[data-dt-tiendas-map-placeholder]");
    if (!mapHost) return;

    const tpl = card ? card.querySelector("template[data-dt-tiendas-iframe]") : null;
    const html = tpl ? tpl.innerHTML.trim() : "";

    if (html) {
      mapHost.innerHTML = html;
      if (placeholder) placeholder.hidden = true;
    } else {
      mapHost.innerHTML = "";
      if (placeholder) placeholder.hidden = false;
    }
  }

  function init(sectionEl) {
    const enableSearch = sectionEl.dataset.enableSearch === "true";

    const input = sectionEl.querySelector("[data-dt-tiendas-search]");
    const clearBtn = sectionEl.querySelector("[data-dt-tiendas-clear]");
    const cards = Array.from(sectionEl.querySelectorAll("[data-dt-tiendas-card]"));
    const countEl = sectionEl.querySelector("[data-dt-tiendas-count]");
    const noResultsEl = sectionEl.querySelector("[data-dt-tiendas-noresults]");

    if (!cards.length) return;

    function renderCount(visibleCount) {
      if (!countEl) return;
      countEl.textContent = `${visibleCount} / ${cards.length}`;
    }

    function setNoResults(isEmpty) {
      if (!noResultsEl) return;
      noResultsEl.hidden = !isEmpty;
    }

    function filter() {
      const q = enableSearch && input ? normalize(input.value) : "";
      let visible = 0;

      cards.forEach((card) => {
        const hay = normalize(card.getAttribute("data-search"));
        const match = q === "" ? true : hay.includes(q);
        card.style.display = match ? "" : "none";
        if (match) visible += 1;
      });

      renderCount(visible);
      setNoResults(visible === 0);

      if (clearBtn && enableSearch) {
        clearBtn.style.visibility = input && input.value ? "visible" : "hidden";
      }

      // Si el activo queda oculto, activa el primero visible
      const active = cards.find((c) => c.classList.contains("is-active") && c.style.display !== "none");
      if (!active) {
        const firstVisible = cards.find((c) => c.style.display !== "none");
        if (firstVisible) {
          setActive(cards, firstVisible);
          updateMap(sectionEl, firstVisible);
        } else {
          updateMap(sectionEl, null);
        }
      }
    }

    // Click card => mapa
    cards.forEach((card) => {
      card.addEventListener("click", (e) => {
        const a = e.target.closest && e.target.closest("a");
        if (a) return; // no interferir con links
        setActive(cards, card);
        updateMap(sectionEl, card);
      });

      card.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setActive(cards, card);
          updateMap(sectionEl, card);
        }
      });
    });

    // Inicial: primera tienda
    setActive(cards, cards[0]);
    updateMap(sectionEl, cards[0]);

    // Search
    if (enableSearch && input) {
      if (clearBtn) {
        clearBtn.addEventListener("click", () => {
          input.value = "";
          input.focus();
          filter();
        });
        clearBtn.style.visibility = "hidden";
      }
      input.addEventListener("input", filter);
    }

    renderCount(cards.length);
    setNoResults(false);
    filter();
  }

  function initAll() {
    document.querySelectorAll(".dt-tiendas[data-section-id]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();